export default __webpack_public_path__ + "static/media/017-hospital.42dbb452.png";